/**
 * Coordinates the source-connect auto-popups (Zoom, Google, Microsoft Teams)
 * so only one opens at a time. Forced opens (user clicked Connect) always
 * win; auto-opens queue behind the currently open dialog and re-evaluate
 * when it closes.
 */
const OPEN_FLAG = "__asSourceConnectPromptOpen";
const CLOSED_EVENT = "as-source-connect-prompt-closed";

export function isAnySourceConnectPromptOpen(): boolean {
  if (typeof window === "undefined") return false;
  return (window as unknown as Record<string, unknown>)[OPEN_FLAG] === true;
}

/** Claim the slot for an auto-open. Returns false when another dialog owns it. */
export function claimSourceConnectPrompt(): boolean {
  if (isAnySourceConnectPromptOpen()) return false;
  (window as unknown as Record<string, unknown>)[OPEN_FLAG] = true;
  return true;
}

/** Claim the slot for a user-initiated (forced) open. */
export function forceClaimSourceConnectPrompt(): void {
  (window as unknown as Record<string, unknown>)[OPEN_FLAG] = true;
}

export function releaseSourceConnectPrompt(): void {
  if (typeof window === "undefined") return;
  (window as unknown as Record<string, unknown>)[OPEN_FLAG] = false;
  window.dispatchEvent(new CustomEvent(CLOSED_EVENT));
}

export function onSourceConnectPromptClosed(listener: () => void): () => void {
  window.addEventListener(CLOSED_EVENT, listener);
  return () => window.removeEventListener(CLOSED_EVENT, listener);
}
